
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1729477994547",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2760",
    "width": "16",
    "height": "16"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M494.72555121 1009.721313L788.51184055 711.08852519l-172.82492782 0L615.68691273 312.91147481 788.51184055 312.91147481 494.72555121 14.278687 235.48815945 312.91147481l172.82492782 0 0 398.17705038-172.82492782 0 259.23739176 298.63278781z",
        "fill": "#2c2c2c",
        "p-id": "2761"
      }
    }
  ]
})
    }
  